import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from "@angular/common/http";

import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  constructor(private router: Router) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token: string = localStorage.getItem('token');
    if (token) {
      request = request.clone({
        headers: request.headers.set("Authorization", token)
      });
    }

    request = request.clone({
      params: request.params.set("lang", localStorage.getItem('lang'))
    });
    // request = request.clone({
    //   headers: request.headers.set("Access-Control-Allow-Credentials", "true")
    // });
    // // tslint:disable-next-line:max-line-length
    // request = request.clone({
    //   headers: request.headers.set(
    //     "Access-Control-Allow-Headers",
    //     "Origin, X-Requested-With, Content-Type, Accept"
    //   ).set('Cache-Control', 'no-cache')
    //     .set('Pragma', 'no-cache')
    // });
    // request = request.clone({
    //   headers: request.headers.set("Accept", "application/json")
    // });

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 || error.statusText === "Unauthorized") {
          /* Server down or unauthorized*/
          console.error(error);
          this.router.navigate(["./login"]);
        } else {
          let data = {};
          data = {
            reason: error && error.error.reason ? error.error.reason : "",
            status: error.status
          };
          return throwError(error);
        }
      })
    );
  }
}
